import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { TASKS_URL } from "./api-url.constants";
import { UpdateTaskApiDTO } from "./dtos/update-task.api.dto";

export const updateTask = async (data: UpdateTaskApiDTO): Promise<void> => {
  const { _id, ...rest } = data;

  const result = await typedFetch(`${TASKS_URL}/${_id}`, {
    method: API_METHODS.PUT,
    body: JSON.stringify(rest),
  });

  if (!result.ok) {
    throw new Error("Failed to update task");
  }
};
